import { Pipe, PipeTransform } from '@angular/core';
import { OfferSetSharingRuleFilterModel } from '../model/offer-set-sharing-rule-filter.model';
import { MakeModel } from '../model/make.model';
import {OfferSetSharingRuleFilterDefinitionModel} from '../model/offer-set-sharing-rule-filter-definition.model';
import { StringFormatterService } from '../service/utilities/string-formatter.service';

@Pipe({
  name: 'offerSetRuleSummary',
  pure: true
})
export class OfferSetRuleSummaryPipe implements PipeTransform {
  constructor(private stringFormatter: StringFormatterService) {}


  transform(filter: OfferSetSharingRuleFilterModel, filterDefinitions: OfferSetSharingRuleFilterDefinitionModel[], makes: MakeModel[]): string {
    const definition = filterDefinitions.find(def => def.id === filter.offerSetSharingRuleFilterDefinitionId);
    let name = definition?.filterName || 'Unknown';
    let valueText = filter.value;

    if (!filter.value || filter.value === 'null') {
      valueText = '';
    }

    if (definition?.filterName === 'Make') {
      const makeIds = this.parseDropdownValues(filter.value);
      valueText = this.formatMakeValue(makeIds, makes);
    }

    return this.formatOutput(name, filter.operator, valueText);
  }

  /**
   * Parse the filter value into an array of make IDs
   */
  private parseDropdownValues(filterValue: string): number[] {
    let result: number[] = this.parseSingleValue(filterValue);

    if (filterValue.includes(',')) {
      result = this.stringFormatter.parseSingleRowCsv(filterValue)
        .map(value => Number(value.trim()))
        .filter(id => !isNaN(id));
    }

    return result;
  }

  /**
   * Parses a single string value into an array containing a numeric value
   */
  private parseSingleValue(filterValue: string): number[] {
    const numValue = Number(filterValue);
    let result: number[] = [];

    if (!isNaN(numValue)) {
      result = [numValue];
    }

    return result;
  }

  /**
   * Format the make display based on the number of makes
   */
  private formatMakeValue(makeIds: number[], makes: MakeModel[]): string {
    let output = `${makeIds.length} Selected`;

    if (makeIds.length < 4) {
      output = this.getMakeNames(makeIds, makes).join(', ');
    }

    return output;
  }

  /**
   * Convert make IDs to display names
   */
  private getMakeNames(makeIds: number[], makes: MakeModel[]): string[] {
    return makeIds.map(id => {
      const make = makes.find(make => make.id === id);
      return make?.displayName || `Unknown(${id})`;
    });
  }

  /**
   * Format the final output string
   */
  private formatOutput(name: string, operator: string, valueText: string): string {
    let output = `${name} ${operator} '${valueText}'`;

    if (name === 'Make' && valueText.includes('Selected')) {
      output = `${name} - ${valueText}`;
    }

    return output;
  }
}
